export abstract class BaseChartStyle {
    readonly newLine = "\n";
    readonly groupsDelimiter = ", "; // ⁝, ·
    readonly valuesDelimiter = "/";
    readonly currentBalanceSuffix = "M..";
    readonly customBalanceSuffix = "C..";
    readonly expirationBalanceSuffix = "E..";
    readonly priceSuffix = "P..";
    readonly impliedVolatilitySuffix = "IV..";
    readonly customImpliedVolatilityAbdBalanceSuffix = "CIV..";
    readonly deltaSuffix = "Δ..";

    abstract get selectedCurrentLineColour(): string;

    abstract get selectedCustomLineColour(): string;

    abstract get selectedExpirationLineColour(): string;

    get balancerPriceLineColour() { return 'rgb(3 118 197)'; }

    abstract get selectedCurrentLineType(): string;

    abstract get selectedCustomLineType(): string;

    abstract get selectedExpirationLineType(): string;

    abstract get comparedCurrentLineColour(): string;

    abstract get comparedCustomLineColour(): string;

    abstract get comparedExpirationLineColour(): string;

    abstract get underlyingLineColour(): string;

    abstract get zeroBalanceLineColour(): string;

    abstract get trendLineColour(): string;

    abstract get comparedCurrentLineType(): string;

    abstract get comparedCustomLineType(): string;

    abstract get comparedExpirationLineType(): string;


    abstract get deltaColour(): string;

    abstract get styleFontWeight(): string;

    abstract get styleFontSize(): string;
    
    
    abstract get trendLineType(): string;

    abstract get trendLineWidth(): number;

    abstract get outTrendAreaColour(): string;

    abstract get tradeSessionBalanceLineColour(): string;

    abstract get selectedLineWidth(): number;

    abstract get comparedLineWidth(): number;

    abstract get impliedVolatilityLineColour(): string;
    
    abstract get impliedVolatilityLineType(): string;
    
    abstract get impliedVolatilityLineWidth(): number;
}
